import { useMemo, useRef } from 'react'
import { CraftAssetField } from 'tsconfig/craft-types'
import { MFormieForm } from '../molecules/m-formie-form'

export type CContactFormBlock = {
  id?: string
  typeHandle?: string
  idName?: string
  backgroundImage?: Array<CraftAssetField>
  backgroundImageMobile?: Array<CraftAssetField>
  heading?: string
}

type CContactFormField = {
  handle?: string
  /** Formie 1 and 2 */
  name?: string
  /** Formie 3 (Craft 5) */
  label?: string
  required?: boolean
  placeholder?: string
  enableConditions?: boolean
  conditions?: string
  typeName?: string
  errorMessage?: string
  options?: Array<{
    label?: string
    value?: string
    isDefault?: boolean
  }>
  /** Field_Agree's text: plain text on Formie 1, HTML on Formie 3 */
  descriptionHtml?: string
}

export type CContactFormFields = {
  handle: string
  /** Formie 1 (Craft 3) */
  fields?: Array<CContactFormField>
  /** Formie 2 and 3 (Craft 4 and 5) */
  formFields?: Array<CContactFormField>
}

type Props = {
  field: Array<CContactFormBlock>
  formFields: CContactFormFields['fields']
}

export const CContactForm = ({ field, formFields }: Props) => {
  const sectionRef = useRef<HTMLDivElement>(null)

  const content = useMemo(() => {
    return field ? field[0] : null
  }, [field])

  if (!content) {
    return <></>
  }

  return (
    <section
      ref={sectionRef}
      className="c-cta relative flex items-center overflow-hidden py-8 bg-neutral-light-gray"
    >
      <span id="contact-us" className="absolute top-0 -mt-[95px]" />
      <div className="px-8 lg:px-18 w-full z-10 flex flex-col items-center py-8">
        {content.heading && (
          <h2 className="text-h6 md:text-h5 text-neutral-dark-gray text-center max-w-[702px] font-light">
            {content.heading}
          </h2>
        )}
        <MFormieForm fields={formFields} />
      </div>
    </section>
  )
}
